import templateUrl from "emun.order/order-details-top-nav.htm";

export default () => ({ templateUrl });
